import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  const location = useLocation();

  const handleAboutTopLink = (
    e: React.MouseEvent<HTMLAnchorElement>,
    path: string
  ) => {
    const isAboutPage = location.pathname === '/about';
    const isAboutTopLink = path === '/about' || path === '/about#philosophy';
    if (isAboutPage && isAboutTopLink) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleImplementationFlowLink = (
    e: React.MouseEvent<HTMLAnchorElement>,
    path: string
  ) => {
    const isImplementationPage = location.pathname === '/implementation';
    const implementationAnchors: Record<string, string> = {
      '/implementation#individual': 'individual',
      '/implementation#corporate': 'corporate',
      '/implementation#educational': 'educational',
      '/implementation#flow': 'flow',
    };
    const anchorId = implementationAnchors[path];
    if (isImplementationPage && anchorId) {
      e.preventDefault();
      const el = document.getElementById(anchorId);
      if (el) {
        const headerOffset = 100;
        const elementTop = el.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({ top: elementTop - headerOffset, behavior: 'smooth' });
      }
    }
  };

  const handleLinkClick = (
    e: React.MouseEvent<HTMLAnchorElement>,
    path: string
  ) => {
    handleAboutTopLink(e, path);
    handleImplementationFlowLink(e, path);
  };

  const footerSections = [
    {
      titleKey: 'footer_about_title',
      links: [
        { labelKey: 'footer_about_link1', path: '/about' },
        { labelKey: 'footer_about_link2', path: '/about#founder-message' },
        { labelKey: 'footer_about_link3', path: '/about#philosophy' },
      ],
    },
    {
      titleKey: 'footer_program_title',
      links: [
        { labelKey: 'footer_program_link1', path: '/dream-code#courses' },
        { labelKey: 'footer_program_link2', path: '/cases' },
      ],
    },
    {
      titleKey: 'footer_intro_title',
      links: [
        { labelKey: 'footer_intro_link1', path: '/implementation#individual' },
        { labelKey: 'footer_intro_link2', path: '/implementation#corporate' },
        { labelKey: 'footer_intro_link3', path: '/implementation#educational' },
      ],
    },
    {
      titleKey: 'footer_other_title',
      links: [
        { labelKey: 'footer_other_link1', path: '/awards' },
        { labelKey: 'footer_other_link2', path: '/contact' },
      ],
    },
  ];

  const legalLinkText =
    lang === 'en'
      ? 'LEGAL / Legal Provisions'
      : lang === 'zh'
      ? 'LEGAL / 法律规定'
      : 'LEGAL / 法的規定';

  return (
    <footer style={{ backgroundColor: '#0f2350' }} className="pt-10 pb-8">
      <div className="max-w-[1200px] mx-auto px-6">

        {/* Sub Nav */}
        <div className="flex flex-col sm:flex-row items-center sm:items-start justify-center gap-10 mb-10">
          <div className="flex-shrink-0 flex sm:items-start items-center">
            <img
              src="https://static.readdy.ai/image/21eccc7cda4592add8699af0788627b0/f8b681da24499350f405fe34f492117c.png"
              alt="Dream Realization Academy"
              className="h-20 w-auto"
            />
          </div>

          <div className="flex flex-wrap justify-center sm:justify-start gap-x-10 gap-y-6">
            {footerSections.map((section, index) => (
              <div key={index} className="min-w-[120px]">
                <h3
                  className="inline-block bg-[#D4AF37] text-[#0f2350] text-[10px] font-extrabold mb-3 tracking-[0.15em] uppercase px-2 py-1 rounded"
                  style={{ fontFamily: 'Montserrat, sans-serif' }}
                >
                  {t(section.titleKey)}
                </h3>
                <ul className="space-y-2">
                  {section.links.map((link, linkIndex) => (
                    <li key={linkIndex}>
                      <Link
                        to={link.path}
                        onClick={(e) => handleLinkClick(e, link.path)}
                        className="text-white/70 text-sm hover:text-white transition-colors duration-200 whitespace-nowrap"
                        style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
                      >
                        {t(link.labelKey)}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* Legal Link */}
        <div className="border-t border-white/10 pt-5 pb-3 flex items-center justify-center">
          <Link
            to="/legal"
            className="text-white/50 text-xs hover:text-white/80 transition-colors duration-200 whitespace-nowrap"
            style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
          >
            {legalLinkText}
          </Link>
        </div>

        {/* Copyright */}
        <div className="pt-3 flex items-center justify-center">
          <p
            className="text-white/40 text-xs"
            style={{ fontFamily: 'Montserrat, sans-serif' }}
          >
            © 2026 DREAM REALIZATION ACADEMY. All rights reserved.
          </p>
        </div>

      </div>
    </footer>
  );
}